module.exports = __webpack_public_path__ + "static/media/cart-icon-hover.ac95af63.svg";